export default {
  title: {
    en: 'Address Verification',
  },
  addressNotFound: {
    en: `
    There is a problem with the address provided. Your address has not been found.
    We highly recommend to update your shipping address.
  `,
  },
  wrongAddress: {
    en: `
      There is a problem with the address provided - we've marked our suggestions <span>in red</span> below.
      Please choose which version of the address you want to use, or click Edit next to the address you
      want to change.
    `,
  },
}
